import { PeticaoArea } from "./peticao-area.model";

export class Peticao {

  Id: number;
  Descricao: string;
  AreaId: number;
  Area: PeticaoArea;
  Arquivo: File;
  Ativo: boolean;
  Extensao: string;
  constructor() {
    this.Id = 0;
    this.Descricao = "";
  }

}
